@if (loader.loading()) {
    <div class="loader-backdrop">
        <img
            ngSrc="https://cdn.lokos.in/lokos-in/assets/LokOS-Circle-Animation.gif"
            alt="Loading..."
            width="120"
            height="120"
            priority
        />
    </div>
}
